import {defineStore} from "pinia";
import {reactive, ref} from "vue";
import {AxiosListResponse} from "@/types/response";
import axios from "axios";

/**
 * 权限
 */
export const useAuthCodeStore = defineStore("authCodeStore", () => {

    const authCodeMap = ref<Record<string, boolean>>()

    async function reload() {
        authCodeMap.value = {};
        console.log("reload authCode")
        const res: AxiosListResponse<string> = await axios.post("pc/auth/allAuth")
        if (res.data.code == 0) {
            let map: Record<string, boolean> = {};
            res.data.data.forEach((code) => {
                map[code] = true
            })
            authCodeMap.value = map
            console.log(map)
        }
    }

    function clear() {
        authCodeMap.value = undefined;
    }

    function hasCode(code: string) {
        if (authCodeMap.value) {
            return authCodeMap.value[code] || false;
        } else {
            reload();
            return false;
        }
    }

    return {
        reload, clear, hasCode
    }


})